/**
 * Integration Adapter
 * Transforms integration-related data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type { IntegrationAccount, IntegrationAccountResponseDto } from '@/types';

export class IntegrationAdapter extends BaseAdapter {
  /**
   * Adapts integration account from API response
   */
  static fromApi(dto: IntegrationAccountResponseDto): IntegrationAccount {
    return {
      id: dto.id,
      name: dto.name,
      isConnected: dto.isConnected,
      // Normalised to a string here, once, rather than at each comparison:
      // machine's bu_id is a BIGINT and the selected-brand atom holds a string, so
      // an un-normalised number compares unequal to the selection and files every
      // card under the wrong brand.
      buId: dto.buId === null || dto.buId === undefined ? null : String(dto.buId),
      authMetaData: dto.authMetaData,
      isPrimary: dto.isPrimary
    };
  }

  /**
   * Adapts integration accounts array from API response
   */
  static fromApiList(dtos: IntegrationAccountResponseDto[]): IntegrationAccount[] {
    return dtos.map((dto) => this.fromApi(dto));
  }
}

